module.exports = __webpack_public_path__ + "img/id-back.1db85e24.svg";